import { defineMessages } from 'react-intl'

export default defineMessages({
  addingRole: {
    id: 'OrganizationSpaces.AddingSpaceAdminRole',
    defaultMessage: 'Adding space administrator role to user'
  },
  back: {
    id: 'Back',
    defaultMessage: 'Back'
  },
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  create: {
    id: 'Create',
    defaultMessage: 'Create'
  },
  creatingSpace: {
    id: 'OrganizationSpaces.CreatingSpace',
    defaultMessage: 'Creating space'
  },
  description: {
    id: 'OrganizationSpaces.Description',
    defaultMessage: 'Description'
  },
  descriptionPlaceholder: {
    id: 'Description',
    defaultMessage: 'Description'
  },
  email: {
    id: 'Email',
    defaultMessage: 'Email'
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  },
  requiredError: {
    id: 'FormError.Required',
    defaultMessage: 'Please enter a value.'
  },
  spaceId: {
    id: 'OrganizationSpaces.SpaceId',
    defaultMessage: 'Space Id'
  },
  spaceName: {
    id: 'OrganizationSpaces.SpaceName',
    defaultMessage: 'Space Name'
  },
  spaceNameAlreadyExists: {
    id: 'OrganizationSpaces.SpaceName.AlreadyExists',
    defaultMessage: 'Space with this name already exists for this organization'
  },
  createSpace: {
    id: 'OrganizationSpaces.CreateSpace',
    defaultMessage: 'Create Space'
  },
  editSpace: {
    id: 'OrganizationSpaces.EditSpace',
    defaultMessage: 'Edit Space'
  },
  title: {
    id: 'OrganizationSpaces.Title',
    defaultMessage: 'Spaces'
  },
  update: {
    id: 'Update',
    defaultMessage: 'Update'
  },
  updatingSpace: {
    id: 'OrganizationSpaces.UpdatingSpace',
    defaultMessage: 'Updating space'
  },
  users: {
    id: 'users',
    defaultMessage: 'users'
  }
})
